import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";
import {
  getAllReportsData,
  saveAllReportsData,
  exportReportData,
  saveLogEntity,
  getLogEntity,
  getAuditLogs,
  aggregateSyncHealth,
  syncHealth,
  syncHealthSession,
  syncHealthManualSync,
  sendUploadTargetTemplateFile,
  bulkUploadTargetSalesData
} from "../slices";
import { toastError, toastSuccess } from "../../utils/react-toaster";
import { getErrorMessage, pos_errormap_with_label, pos_errormap_with_label_for_rista_card } from "../../helpers/errors-helper";
import { FILE_UPLOADED_SUCCESSFULLY } from "../../data/rista-card-constants";

async function commonPostData(url: string, data: any) {
  try {
    const postApi = api.request({
      method: "POST",
      url: url,
      data,
    });
    const fetchResponse = await postApi;
    return fetchResponse;
  } catch (e) {}
}
export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  code?: string;
  email?: string;
}

function* fetchAllReportsData() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.REPORTS.getAllReports(),
    });
    yield put(saveAllReportsData(response));
  } catch (error) {
    console.log(error);
  }
}

function* exportReport(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.REPORTS.exportReport(actions.payload.dataToPost.source),
      data: actions.payload.dataToPost,
    });
    actions.payload?.callback && actions.payload.callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* fetchAggregateSyncHealth(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.REPORTS.aggregateSyncHealth(),
      data: actions.payload.payload,
    });
    actions.payload.callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* fetchSyncHealth(action: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.REPORTS.syncHealth(),
      data: action.payload.payload,
    });
    action.payload.callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* fetchSyncHealthSession(action: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.REPORTS.syncHealthSession(),
      data: action.payload.payload,
    });
    action.payload.callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* postSyncHealthManualSync(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.REPORTS.syncHealthManualSync(),
      data: actions.payload.payload,
    });
    actions.payload.callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* fetchLogEntity() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.REPORTS.logEntity(),
    });
    yield put(saveLogEntity(response));
  } catch (error) {
    console.log(error);
  }
}

function* fetchAuditLogs(action: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.REPORTS.fetchLogReport(),
      data: action.payload.dataToPost,
    });
    action.payload?.callback && action.payload.callback(response);
  } catch (error) {
    console.log(error);
  }
}

function* uploadTargetTemplateFile(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: "GET",
      url: ENDPOINT.REPORTS.uploadTargetTemplateFile,
    });
    if (!response?.code) {
      actions?.payload?.callback && actions?.payload?.callback(response);
    } else if (pos_errormap_with_label[response?.code]) {
      toastError(
        getErrorMessage(pos_errormap_with_label, response?.code, actions.payload?.userEmail),
      );
    }
  } catch (error) {
    console.log(error);
  }
}

function* bulkUploadTargetSales(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: "POST",
      url: ENDPOINT.REPORTS.bulkUploadTargetSales,
      data: actions?.payload?.dataToPost,
    });
    if(!response?.code && response?.email) {
      toastSuccess(pos_errormap_with_label_for_rista_card[FILE_UPLOADED_SUCCESSFULLY]);
      actions?.payload?.callback && actions?.payload?.callback(response);
    } else if (response?.code && pos_errormap_with_label_for_rista_card[response.code]) {
      toastError(
        getErrorMessage(
          pos_errormap_with_label_for_rista_card,
          response.code,
          response?.email
        )
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(getAllReportsData.type, fetchAllReportsData);
  yield takeEvery(exportReportData.type, exportReport);
  yield takeEvery(getLogEntity.type, fetchLogEntity);
  yield takeEvery(getAuditLogs.type, fetchAuditLogs);
  yield takeEvery(aggregateSyncHealth.type, fetchAggregateSyncHealth);
  yield takeEvery(syncHealth.type, fetchSyncHealth);
  yield takeEvery(syncHealthSession.type, fetchSyncHealthSession);
  yield takeEvery(syncHealthManualSync.type, postSyncHealthManualSync);
  yield takeEvery(sendUploadTargetTemplateFile.type, uploadTargetTemplateFile);
  yield takeEvery(bulkUploadTargetSalesData.type, bulkUploadTargetSales);
}
